import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IrisActivityFiltersDTO,
  IrisReportResponse,
  IrisSummaryFiltersDTO,
  IrisUserActivity,
  IrisUserActivityDetail,
} from '../types/iris-report';
import { PaymentsApiRequestService } from './payments.request.service';

@Injectable()
export class IrisService {
  constructor(private request: PaymentsApiRequestService) {}

  getBankSummary(
    civilId: string,
    filters?: IrisSummaryFiltersDTO
  ): Observable<IrisReportResponse> {
    const params: Record<string, string> = {};

    if (filters?.dateFrom) {
      params['dateFrom'] = filters.dateFrom;
    }
    if (filters?.dateTo) {
      params['dateTo'] = filters.dateTo;
    }
    if (filters?.description) {
      params['description'] = filters.description;
    }
    if (filters?.amountFrom != null) {
      params['amountFrom'] = String(filters.amountFrom);
    }
    if (filters?.amountTo != null) {
      params['amountTo'] = String(filters.amountTo);
    }

    return this.request.get(['iris', civilId, 'summary'], { params });
  }

  updateSummary(civilId: string): Observable<boolean> {
    return this.request.post(['iris', civilId, 'sync-bank-data']);
  }

  deactivateConsent(userId: string, iban: string): Observable<boolean> {
    return this.request.delete(['iris', 'user', userId, 'consent', iban]);
  }

  getActivityUsers(
    filters?: IrisActivityFiltersDTO
  ): Observable<IrisUserActivity[]> {
    return this.request.get(['iris', 'admin', 'activity', 'user'], {
      params: { ...filters },
    });
  }

  getActivityUser(id: number): Observable<IrisUserActivityDetail> {
    return this.request.get(['iris', 'admin', 'activity', 'user', String(id)]);
  }
}
